// extracted by mini-css-extract-plugin
export default {"button":"buynow_button__jDgna"};